module.exports = __webpack_public_path__ + "static/media/bonnie.2cf24f3b.png";